'use client';

import React from 'react';
import LinkLocalized from '@/components/nav/LinkLocalized';
import { usePathname } from 'next/navigation';
import { NavItem } from '@/components/nav/Header';

type Props = {
  item: NavItem;
};

export function HeaderLink({ item }: Props) {
  const selected = new RegExp(item.pattern).test(usePathname() ?? '');

  return (
    <LinkLocalized href={item.href}>
      <div
        className={`flex shrink-0 px-3 py-1 transition-all duration-300  ${
          selected ? 'rounded-md bg-gray-100 dark:bg-gray-800' : ''
        }`}
      >
        <span className="mr-1">{item.icon}</span>{' '}
        <span className="font-bold capitalize">{item.label}</span>
      </div>
    </LinkLocalized>
  );
}
